import dayjs from "dayjs";
import { useMemo } from "react";
import { useLocale } from "./useLocale";

export const useFirstDayOfWeek = (): "sunday" | "monday" => {
  const locale = useLocale();
  return useMemo(() => {
    return dayjs().day(0).isSame(dayjs().weekday(0)) ? "sunday" : "monday";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
};
